import { Box, CircularProgress, Container } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Text from "../ui/Text";

const PublicRoute = ({ children, redirectTo = "/dashboard" }) => {
  const { currentUser, loading } = useAuth();

  // Show loading spinner while Firebase is determining auth state
  if (loading) {
    return (
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Text variant="paragraph3" sx={{ color: "#666" }}>
            Loading...
          </Text>
        </Box>
      </Container>
    );
  }

  // If user is authenticated, redirect to dashboard (or specified route)
  if (currentUser) {
    return (
      <Navigate
        to={
          currentUser?.profile_setup_completed ? redirectTo : "/account-setup"
        }
        replace
      />
    );
  }

  // User is not authenticated, show the public content (auth pages)
  return children;
};

export default PublicRoute;
